<template>
  <div class="card" style="margin: 2rem">
    <table id="customers">
      <tr>
        <th>ID Ponto</th>
        <th>Nome Plano</th>
        <th>Status</th>
        <th>Ação</th>
      </tr>
      <tr v-for="point in client.points" :key="point.id">
        <td>{{ point.id }}</td>
        <td>{{ point.plan ? point.plan.name : '-' }}</td>
        <td>{{ formatStatus(point.status) }}</td>
        <td>
          <input v-model="pointIds" :value="point.id" @change="canContinue" type="checkbox" />
        </td>
      </tr>
    </table>
  </div>
</template>

<script>
import { mapActions } from "vuex";
export default {
  props: ["clickedNext", "currentStep"],
  computed: {
    client() {
      return this.$store.getters.client;
    }
  },
  data() {
    return {
      pointIds: []
    };
  },
  methods: {
    ...mapActions(["setSelectedPointIds"]),
    canContinue() {
      this.setSelectedPointIds({ pointIds: this.pointIds });
      this.$emit("can-continue", { value: this.pointIds.length > 0 });
    },
    formatStatus(value) {
      const map = new Map([
        [19, "Aguardando 1. Conexão"],
        [27, "Ativo"],
        [58, "Em aviso"],
        [43, "Bloqueado"],
        [26, "Não instalado"],
        [35, "Congelado"],
        [51, "Cancelado"],
        [52, "Cancelado inadimpl."],
        [96, "Isento"],
        [105, "Aguardando aceite"]
      ]);
      return map.get(value);
    }
  },
  mounted() {
    this.$emit("can-continue", { value: false });
  }
};
</script>

<style scoped>
.control {
  display: flex;
}
.control button {
  background-color: #005663;
  color: #fff;
  border: none;
  border-radius: 2px;
  cursor: pointer;
}

#customers {
  font-family: Arial, Helvetica, sans-serif;
  border-collapse: collapse;
  width: 100%;
}

#customers td,
#customers th {
  border: 1px solid #ddd;
  padding: 8px;
}

#customers tr:nth-child(even) {
  background-color: #f2f2f2;
}

#customers tr:hover {
  background-color: #ddd;
}

#customers th {
  padding-top: 12px;
  padding-bottom: 12px;
  text-align: left;
  background-color: #005663;
  color: white;
}
</style>